export const sideBarWidth = '200px';

export const sideBarWidthXs = '15%';

